import { Link } from "react-router-dom";
import { ASSETS, CONTACTS } from "../lib/data";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[var(--cx-border)] bg-[var(--cx-black)] py-16">
    <div className="cx-container">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <Link to="/" className="flex items-center">
          <img src={ASSETS.logo} alt="Connexa" className="h-20 w-auto object-contain md:h-24" />
        </Link>
        <div className="flex flex-wrap gap-x-10 gap-y-3 font-body text-sm text-[var(--cx-white)]/70">
          <a href={CONTACTS.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="link-underline">Instagram</a>
          <a href={`https://wa.me/${CONTACTS.home.intl}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-home" className="link-underline">WhatsApp Home</a>
          <a href={`https://wa.me/${CONTACTS.auto.intl}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-auto" className="link-underline">WhatsApp Auto</a>
          <a href={`mailto:${CONTACTS.email}`} data-testid="footer-email" className="link-underline">{CONTACTS.email}</a>
        </div>
      </div>
      <div className="gold-rule my-10 opacity-40" />
      <p className="font-body text-xs tracking-wide text-[var(--cx-muted)]">
        © {new Date().getFullYear()} Connexa. Tutti i diritti riservati.
      </p>
    </div>
  </footer>
);
